import { render } from "./HeaderLayout.vue?vue&type=template&id=25fe8c2c&scoped=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import "./HeaderLayout.vue?vue&type=style&index=0&id=25fe8c2c&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fe8c2c"]])

export default __exports__